function getTransformedImage(src, pixelCrop, rotation, fileName, isSrcDataURL) {
  return new Promise((resolve, reject) => {
    const image = document.createElement('img')
    image.setAttribute("crossorigin","anonymous")

    image.onload = function() {
      const finalWidth = (pixelCrop.width / 100.0) * image.width
      const finalHeight = (pixelCrop.height / 100.0) * image.height
      const sourceX = pixelCrop.x * image.width / 100.0
      const sourceY = pixelCrop.y * image.height / 100.0
      const canvas = document.createElement('canvas');

      switch (rotation) {
        case 1:
        case 3:
          canvas.width = finalHeight;
          canvas.height = finalWidth;
          break;
        default:
          canvas.width = finalWidth;
          canvas.height = finalHeight;
      }
      const ctx = canvas.getContext('2d');
      switch (rotation) {
        case 1:
          ctx.rotate(90*Math.PI/180);
          ctx.translate(0,-finalHeight);
          break
        case 2:
          ctx.rotate(180*Math.PI/180);
          ctx.translate(-finalWidth,-finalHeight);
          break
        case 3:
          ctx.rotate(270*Math.PI/180);
          ctx.translate(-finalWidth,0);
          break
        default:
      }

      ctx.drawImage(
        image,
        sourceX,
        sourceY,
        finalWidth,
        finalHeight,
        0,
        0,
        finalWidth,
        finalHeight
      );
      ctx.restore()

      canvas.toBlob(file => {
        if(file){
            file.name = fileName;
        }
        resolve(file);
      }, 'image/jpeg');
    }

      image.src = isSrcDataURL ? src : cacheBustedSrc(src)
    });
  }

  // Workaround to make CORS work on chrome. The problem is when the
  // same image is displayed without CORS (ex. without crossorigin attribute)
  // and later displayed with CORS. S3 does not return cors header when Origin
  // header is not present thus CORS and the Origin header is not present when image
  // is downloaded without CORS (without crossorigin attribute). Browser caches
  // response to the first response and the second fails because CORS headers are
  // missing in the cached response. This workaround adds a token to the query so
  // that a new request is made
  // https://stackoverflow.com/questions/31732533/s3-cors-always-send-vary-origin
  function cacheBustedSrc(src){
    const url = new URL(src)
    const cacheButstingToken = 'cors'
    if(url.search){
        url.search = url.search + cacheButstingToken
    }else{
      url.search = cacheButstingToken
    }
    return url
  }
  export { getTransformedImage }



// WEBPACK FOOTER //
// ./src/component/imageTransformer.js